"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = void 0;
const monda_1 = require("@simplisafe/monda");
const browser_monads_1 = require("browser-monads");
// returns either Desktop or Mobile
function getDeviceType() {
    const h = (0, monda_1.safePath)(['screen', 'height'], browser_monads_1.window).getOrElse(0);
    const w = (0, monda_1.safePath)(['screen', 'width'], browser_monads_1.window).getOrElse(0);
    const isMobile = Math.min(h, w) < 480 && (0, monda_1.safePath)(['navigator', 'userAgent'], browser_monads_1.window).getOrElse('')
        .indexOf('Mobi') > -1;
    return (isMobile) ? 'Mobile' : 'Desktop';
}
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=windowScreenSize.js.map